import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, useLocation, useNavigate } from 'react-router-dom';
import AppRoutes from './routes/app-routes';
import LayoutWrapper from './modules/layout/LayoutWrapper';
import axios from 'axios';
import API_BASE_URL from './components/apiconfig/api-config';

const LayoutDecider = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [authChecked, setAuthChecked] = useState(false);
  
  useEffect(() => {
    const noLayoutRoutes = ['/', '/login']; // Removed /register from noLayoutRoutes
    
    const checkAuth = async () => {
      try {
        await axios.get(`${API_BASE_URL}/api/auth/protected`, {
          withCredentials: true,
        });
        setAuthChecked(true);
      } catch (err) {
        try {
          // Try refreshing token
          await axios.post(`${API_BASE_URL}/api/auth/refresh-token`, {}, { 
            withCredentials: true 
          });
          setAuthChecked(true);
        } catch {
          // Don't redirect to '/' for login page
          if (location.pathname !== '/login') {
            navigate('/login', { replace: true });
          }
        }
      }
    };

    // Only check auth for protected routes
    if (!noLayoutRoutes.includes(location.pathname)) {
      checkAuth();
    } else {
      // Clear any stale auto-logout deadline when on public routes (login/home)
      try {
        localStorage.removeItem('auto_logout_deadline');
      } catch (e) {}
      setAuthChecked(true); // Skip check for public routes
    }
  }, [location.pathname, navigate]);

  if (!authChecked) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-blue-500"></div>
      </div>
    );
  }

  const noLayoutRoutes = ['/', '/login']; // Removed /register from noLayoutRoutes
  const isNoLayout = noLayoutRoutes.includes(location.pathname);
  return isNoLayout ? <AppRoutes /> : <LayoutWrapper><AppRoutes /></LayoutWrapper>;
};

function App() {
  return (
    <Router>
      <LayoutDecider />
    </Router>
  );
}

export default App;